(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/format-game/assets/javascripts/format.js') >= 0) return;  svs.modules.push('/components/casino/format-game/assets/javascripts/format.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
let isPnp;
let cmsCDN;
let trinidad;
if (isServer) {
  trinidad = require('@svenskaspelab/trinidad-core').core;
  isPnp = trinidad.config.options.site === 'momang';
} else {
  cmsCDN = svs.core.config.data.svsconfig.cdn2;
  isPnp = svs.components.casino.data.isPnpSite;
}
const gamePropertiesDefault = ['articleId', 'id', 'name', 'title', 'provider', 'rtp', 'winLines', 'volatility', 'tags', 'badge', 'jackpot', 'jackpotId', 'lobbyImage', 'tallLobbyImage', 'lobbyType', 'lobbySvgImage', 'freePlayAllowed', 'clientStartType', 'liveTableId', 'disclaimer'];
const gamePropertiesLive = ['articleId', 'id', 'name', 'title', 'provider', 'rtp', 'lobbyType', 'tags', 'badge', 'lobbyImage', 'tallLobbyImage', 'lobbySvgImage', 'clientStartType', 'jackpotId', 'liveCategory', 'liveTableId', 'disclaimer'];
function reduceProps(game) {
  const reduceList = game.lobbyType === 'live' ? gamePropertiesLive : gamePropertiesDefault;
  return Object.keys(game).filter(key => reduceList.includes(key)).reduce((obj, key) => {
    obj[key] = game[key];
    return obj;
  }, {});
}
function getLiveTableId(game, provider) {
  const operatorsUsingSuppIdAsLiveId = ['playtech', 'netent', 'onair'];
  if (operatorsUsingSuppIdAsLiveId.includes(provider === null || provider === void 0 ? void 0 : provider.toLowerCase())) {
    return game.operatorSupplementaryId || '';
  }
  return game.providerGameId;
}
function formatImage(_ref) {
  let image = _ref.image,
    _ref$loadingLazy = _ref.loadingLazy,
    loadingLazy = _ref$loadingLazy === void 0 ? true : _ref$loadingLazy,
    _ref$originalImage = _ref.originalImage,
    originalImage = _ref$originalImage === void 0 ? false : _ref$originalImage,
    gameTitle = _ref.gameTitle;
  return _objectSpread(_objectSpread({}, image), {}, {
    fitWrapper: true,
    loadingLazy,
    sizes: '(min-width: 1024px) 20vw, 40vw',
    aspectRatio: {
      height: image.height,
      width: image.width
    },
    altText: image.altText || "Spela ".concat(gameTitle) || '',
    title: image.title || gameTitle || '',
    originalImage
  });
}

function formatGame(game, reduceProperties) {
  var _game$images;
  if (!game) {
    return undefined;
  }
  const parsedConfig = JSON.parse(game.properties.cnt_casinoGameConfig);
  const volatility = ['Låg', 'Medellåg', 'Medel', 'Medelhög', 'Hög', 'Väldigt hög'];
  const badgeTags = {
    Nyheter: 'Nyhet!',
    Rekommenderat: 'Rekommenderat',
    Jackpotspel: 'Jackpotspel',
    Exklusivt: 'Exklusivt',
    Turnering: 'Turnering!'
  };
  let newGame = {
    id: game.id,
    name: game.name,
    title: game.title,
    description: game.body,
    rank: game.rank,
    lobbyType: parsedConfig.lobbyType,
    category: game.properties.cnt_casinoCategory,
    freePlayAllowed: game.properties.cnt_casinoFreeplayAllowed === true,
    tags: game.properties.cnt_casinoTags,
    provider: game.properties.cnt_casinoProvider,
    rtp: parsedConfig.rtp,
    jackpotId: parsedConfig.jackpotId,
    winLines: parsedConfig.winLines,
    providerGameId: parsedConfig.providerGameId,
    providerGameIdMobile: parsedConfig.providerGameIdMobile,
    opsGameId: parsedConfig.opsGameId,
    opsGameIdMobile: parsedConfig.opsGameIdMobile,
    operatorSupplementaryId: parsedConfig.operatorSupplementaryId,
    clientStartType: parsedConfig.clientStartType,
    clientHeight: parsedConfig.clientHeight,
    clientWidth: parsedConfig.clientWidth,
    clientAllowedOrientation: parsedConfig.clientAllowedOrientation,
    seoDescription: parsedConfig.seoDescription,
    seoKeywords: parsedConfig.seoKeywords,
    articleId: (isPnp ? parsedConfig.momangArticleId : parsedConfig.articleId) || false,
    liveCategory: parsedConfig.liveCategory,
    liveTableId: getLiveTableId(parsedConfig, game.properties.cnt_casinoProvider),
    disclaimer: parsedConfig.disclaimer,
    hasImages: Boolean((_game$images = game.images) === null || _game$images === void 0 ? void 0 : _game$images.length)
  };
  if (parsedConfig.volatility !== undefined) {
    newGame.volatility = volatility[parsedConfig.volatility];
  }
  if (game.properties.cnt_casinoTags) {
    Object.keys(badgeTags).some(tag => {
      if (game.properties.cnt_casinoTags.includes(tag)) {
        newGame.badge = badgeTags[tag];
        return true;
      }
      return false;
    });
  }
  const timedTags = parsedConfig.timedTags || parsedConfig.timedBadges; 
  if (timedTags) {
    const now = Date.now();
    let expiry;
    timedTags.some(tag => {
      expiry = new Date("".concat(tag.expiryDate, "T").concat(tag.expiryTime)).getTime();
      if (now < expiry && tag.badge !== false) {
        if (tag.text || tag.customBadge) {
          newGame.badge = tag.text || tag.customBadge;
        } else {
          newGame.badge = badgeTags[tag.name || tag.badge]; 
        }
        return true;
      }
      return false;
    });
  }
  if (game.images) {
    game.images.forEach(image => {
      if (image.typeName === parsedConfig.lobbyImage.name) {
        newGame.lobbyImage = formatImage({
          image,
          loadingLazy: false,
          originalImage: false,
          gameTitle: game.title
        });
      } else if (parsedConfig.tallLobbyImage && image.typeName === parsedConfig.tallLobbyImage.name) {
        newGame.tallLobbyImage = formatImage({
          image,
          loadingLazy: false,
          originalImage: false,
          gameTitle: game.title
        });
      } else if (parsedConfig.backgroundImage && image.typeName === parsedConfig.backgroundImage.name) {
        newGame.backgroundImage = {
          src: cmsCDN + image.url
        };
      } else if (parsedConfig.lobbySvgImage && image.typeName === parsedConfig.lobbySvgImage.name) {
        newGame.lobbySvgImage = formatImage({
          image,
          loadingLazy: false,
          originalImage: true,
          gameTitle: game.title
        });
      }
    });
  }
  if (reduceProperties) {
    newGame = reduceProps(newGame);
  }
  return newGame;
}

function formatGames(cmsGames) {
  let reduceProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return cmsGames.map(game => formatGame(game, reduceProperties));
}
if (isServer) {
  module.exports = {
    formatGames,
    formatGame,
    getLiveTableId,
    reduceProps
  };
} else {
  svs.components.casino.formatGame = {
    formatGames,
    formatGame,
    getLiveTableId,
    reduceProps
  };
}

 })(window);